import { render, staticRenderFns } from "./PatreonSubdomains.vue?vue&type=template&id=657223c4&scoped=true"
import script from "./PatreonSubdomains.vue?vue&type=script&lang=js"
export * from "./PatreonSubdomains.vue?vue&type=script&lang=js"
import style0 from "./PatreonSubdomains.vue?vue&type=style&index=0&id=657223c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657223c4",
  null
  
)

export default component.exports